import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* const _import = require('./_import_' + process.env.NODE_ENV)
const Foo = _import('Foo') */
// 一种按需加载的写法
// const login = r => require.ensure([], () => r(require('@/views/login')), 'login')

// vue-Router 最新的一种按需加载的写法
// const login = () => import('@/views/login.vue') // /* webpackChunkName: "contrDesk" */会识别打包Chunk
// const login = () => import(/* webpackChunkName: "login" */ '@/views/login/login.vue')
const layout = () => import(/* webpackChunkName: "contrDesk" */ '@/views/Layout.vue')
const home = () => import(/* webpackChunkName: "home" */ '@/views/home.vue')
const fail = () => import(/* webpackChunkName: "fail" */ '@/views/error/fail')
const notfound = () => import(/* webpackChunkName: "notfound" */ '@/views/error/notfound')
const introduction = () => import(/* webpackChunkName: "introduction" */ '@/views/introduction')
const  concept = () => import(/* webpackChunkName: "concept" */ '@/views/concept')
const   speech = () => import(/* webpackChunkName: "speech" */ '@/views/speech')
const  team = () => import(/* webpackChunkName: "team" */ '@/views/team')
const contact = () => import(/* webpackChunkName: "contact" */ '@/views/contact')
const teamDetail = () => import(/* webpackChunkName: "teamDetail" */ '@/views/teamDetail')
const news  = () => import(/* webpackChunkName: "news" */ '@/views/news')
const newDetail  = () => import(/* webpackChunkName: "newDetail" */ '@/views/newDetail')
const achieveDetail = () => import(/* webpackChunkName: "achieveDetail" */ '@/views/achieveDetail')
const achievement = () => import(/* webpackChunkName: "achievement" */ '@/views/achievement')
const server = () => import(/* webpackChunkName: "server" */ '@/views/server')
const about = () => import(/* webpackChunkName: "server" */ '@/views/about')
const mapgo = () => import(/* webpackChunkName: "server" */ '@/views/mapgo')
/** 共用处参考，上线可删掉 ---start */
const test = () => import(/* webpackChunkName: "test" */ '@/views/test/test.vue')
const demo = () => import(/* webpackChunkName: "demo" */ '@/views/test/demo.vue')
/** 共用处参考，上线可删掉 ---end */
export default new Router({
  /* 去掉url中的#号  但是静态放到服务器时，后端需要配置，地址：https://router.vuejs.org/zh-cn/essentials/history-mode.html */
  mode: 'history',
  routes: [
    /* {
      path: '/',
      component: login
    }, */
    {
      path: '/error/fail',
      component: fail
    },
    {
      path: '/error/notfound',
      component: notfound
    },
    {
      path: '/',
      component: layout,
      children: [
        {
          path: '/',
          redirect:to=>{
            return '/home'
          },
          meta: []
        },
        {
          path: '/home',
          component: home,
          meta: []
        },
        {
          path: '/introduction',    //蓝石简介
          component: introduction,
          meta: []
        },
        {
          path: '/concept',        //蓝石理念
          component: concept,
          meta: []
        },
        {
          path: '/speech',        //委员主任致辞
          component: speech,
          meta: []
        },
        {
          path: '/team',        //专业团队
          component: team,
          meta: []
        },
        {
          path: '/contact',        //联系蓝石
          component: contact,
          meta: []
        },
        {
          path: '/team/teamDetail',        //专业团队详情
          component: teamDetail,
          meta: []
        },
        {
          path: '/news',        //要闻刊物
          component: news,
          meta: []
        },
        {
          path: '/news/newDetail',        //要闻刊物详情
          component: newDetail,
          meta: []
        },
        {
          path: '/achievement/achieveDetail',        //业绩详情
          component: achieveDetail,
          meta: []
        },
        {
          path: '/achievement',        //蓝石业绩
          component: achievement,
          meta: []
        },
        {
          path: '/about',        //蓝石地图
          component: about,
          meta: []
        },
        
        {
          path: '/server',        //蓝石服务
          component: server,
          meta: []
        },
        {
          path: '/test',        //
          component: test,
          meta: []
        },
        {
          path: '/mapgo',        //
          component: mapgo,
          meta: []
        },
      ]
    }
  ],
  // scrollBehavior (to, from, savedPosition) {
  //   return new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //       resolve({ x: 0, y: 0 })
  //     }, 500)
  //   })
  // }
  
})
//  const router = new Router({})
//  router.afterEach((to,from,next) => {
//   window.scrollTop(0,0);
// });
// // 全局配置
// router.beforeEach((to, from, next) => {
//   // Change doc title
//   document.querySelector('meta[name="keywords"]').setAttribute('content', 'keywords')
//   document.querySelector('meta[name="description"]').setAttribute('content', 'description')
//   //next();
// })


  



// WEBPACK FOOTER //
// ./src/router/index.js